import { useEffect } from 'react';

export const useQualtrics = (shouldRun: any) => {
    useEffect(() => {
        if (shouldRun) {
            // @ts-expect-error TS2339: Property 'QSI' does not exist on type 'Window & typeof globalThis'.
            window.QSI?.API?.unload();
            // @ts-expect-error TS2339: Property 'QSI' does not exist on type 'Window & typeof globalThis'.
            window.QSI?.API?.load()?.then(window.QSI?.API?.run);
        }
    }, [shouldRun]);
};
